import { parseContextArr, fetchContextData } from '../templates/Internals';
if (!window.openContext)
    window.openContext = openContext;
export function openContext(iEvent, iOpt) {
    let cm;
    if (!iOpt.selector)
        iOpt.selector = 'pic-context[context-x]';
    if (typeof iOpt.selector === 'string' || iOpt.selector instanceof String) {
        //@ts-ignore
        cm = document.querySelector(iOpt.selector);
    }
    else {
        //@ts-ignore
        cm = iOpt.selector;
    }
    if (!cm)
        return;
    if (!iOpt.data)
        if (iOpt.fetchPath) {
            cm.data = { clickEvent: iEvent, contextPromise: fetchContextData(iOpt.fetchPath, iOpt.fetchParm) };
            return;
        }
        else
            iOpt.data = [];
    cm.data = { clickEvent: iEvent, context: parseContextArr(iOpt.data, { callBackFunction: () => { }, parentElmRef: iOpt.selector }) };
}
//# sourceMappingURL=contextmenu.js.map